import { render, staticRenderFns } from "./IcoMenuPage.vue?vue&type=template&id=e88ac180&lang=html"
import script from "./IcoMenuPage.vue?vue&type=script&lang=js"
export * from "./IcoMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports